export default __webpack_public_path__ + "static/media/cto-profile.a9f38c8e.png";